import type { VariantImagesDefinition } from 'types/images'

import { M01_IMAGES } from './default'

export const M01_MEMOJI_OLDER_IMAGES = {
  ...M01_IMAGES,
  socialProofMillions: {
    pitch: {
      ...M01_IMAGES.socialProofMillions.pitch,
      srcSet: [
        '/images/m01/memoji-older/social_proof_millions.webp',
        '/images/m01/memoji-older/social_proof_millions@2x.webp',
      ],
    },
    group: {
      ...M01_IMAGES.socialProofMillions.group,
      srcSet: [
        '/images/m01/memoji-older/social-proof-millions/group.webp',
        '/images/m01/memoji-older/social-proof-millions/group@2x.webp',
      ],
    },
  },
  experience: {
    background: {
      ...M01_IMAGES.experience.background,
      srcSet: [
        '/images/m01/memoji-older/experience.webp',
        '/images/m01/memoji-older/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      ...M01_IMAGES.experiencePitch.pitch,
      srcSet: [
        '/images/m01/memoji-older/experience_pitch.webp',
        '/images/m01/memoji-older/experience_pitch@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      ...M01_IMAGES.howOftenExercise.background,
      srcSet: [
        '/images/m01/memoji-older/how_often_exercise.webp',
        '/images/m01/memoji-older/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      ...M01_IMAGES.howOftenWalks.background,
      srcSet: [
        '/images/m01/memoji-older/how_often_walks.webp',
        '/images/m01/memoji-older/how_often_walks@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      ...M01_IMAGES.flexible.background,
      srcSet: [
        '/images/m01/memoji-older/flexible.webp',
        '/images/m01/memoji-older/flexible@2x.webp',
      ],
    },
  },
  energyPitch: {
    person: {
      ...M01_IMAGES.energyPitch.person,
      srcSet: [
        '/images/m01/memoji-older/energy-pitch/person.webp',
        '/images/m01/memoji-older/energy-pitch/person@2x.webp',
      ],
    },
  },
  waterIntake: {
    header: {
      ...M01_IMAGES.waterIntake.header,
      srcSet: [
        '/images/m01/memoji-older/water_intake.webp',
        '/images/m01/memoji-older/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      ...M01_IMAGES.sleepDuration.header,
      srcSet: [
        '/images/m01/memoji-older/sleep_duration.webp',
        '/images/m01/memoji-older/sleep_duration@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      ...M01_IMAGES.wellnessProfile.extended,
      srcSet: [
        '/images/m01/memoji-older/wellness-profile/wellness_profile_overweight.webp',
        '/images/m01/memoji-older/wellness-profile/wellness_profile_overweight@2x.webp',
      ],
    },
    fullFigured: {
      ...M01_IMAGES.wellnessProfile.fullFigured,
      srcSet: [
        '/images/m01/memoji-older/wellness-profile/wellness_profile_bigger.webp',
        '/images/m01/memoji-older/wellness-profile/wellness_profile_bigger@2x.webp',
      ],
    },
    midSized: {
      ...M01_IMAGES.wellnessProfile.midSized,
      srcSet: [
        '/images/m01/memoji-older/wellness-profile/wellness_profile_medium_build.webp',
        '/images/m01/memoji-older/wellness-profile/wellness_profile_medium_build@2x.webp',
      ],
    },
    slim: {
      ...M01_IMAGES.wellnessProfile.slim,
      srcSet: [
        '/images/m01/memoji-older/wellness-profile/wellness_profile_slender.webp',
        '/images/m01/memoji-older/wellness-profile/wellness_profile_slender@2x.webp',
      ],
    },
  },
  subscription: {
    beforeBigger: {
      ...M01_IMAGES.subscription.beforeBigger,
      srcSet: [
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_before_bigger.webp',
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_before_bigger@2x.webp',
      ],
    },
    beforeMediumBuild: {
      ...M01_IMAGES.subscription.beforeMediumBuild,
      srcSet: [
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_before_medium_build.webp',
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_before_medium_build@2x.webp',
      ],
    },
    beforeSignificantlyOverweight: {
      ...M01_IMAGES.subscription.beforeSignificantlyOverweight,
      srcSet: [
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_before_significantly_overweight.webp',
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_before_significantly_overweight@2x.webp',
      ],
    },
    beforeSlender: {
      ...M01_IMAGES.subscription.beforeSlender,
      srcSet: [
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_before_slender.webp',
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_before_slender@2x.webp',
      ],
    },
    afterAthletic: {
      ...M01_IMAGES.subscription.afterAthletic,
      srcSet: [
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_after_athletic.webp',
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_after_athletic@2x.webp',
      ],
    },
    afterBitLeaner: {
      ...M01_IMAGES.subscription.afterBitLeaner,
      srcSet: [
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_after_a_bit_leaner.webp',
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_after_a_bit_leaner@2x.webp',
      ],
    },
    afterExtraBulky: {
      ...M01_IMAGES.subscription.afterExtraBulky,
      srcSet: [
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_after_extra_bulky.webp',
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_after_extra_bulky@2x.webp',
      ],
    },
    afterShredded: {
      ...M01_IMAGES.subscription.afterShredded,
      srcSet: [
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_after_shredded.webp',
        '/images/m01/memoji-older/subscription/goal-body/paywall_comparison_after_shredded@2x.webp',
      ],
    },
  },
} satisfies VariantImagesDefinition<typeof M01_IMAGES>
